<template>
  <div/>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'NotFoundView',
  setup () {
    const store = useStore()
    store.commit('setNotFound', true)
  }
}
</script>

<style lang="scss"/>
